import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import MyAccount from '../views/MyAccount'
import Login from '../views/Login'

Vue.use(VueRouter)

  const routes = [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
          path: '/account',
          name: 'MyAccount',
          component: MyAccount
      },
      {
          path: '/login',
          name: 'Login',
          component: Login
      }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
